import { render } from "./SearchForm.vue?vue&type=template&id=a65319f0&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "@/assets/css/SearchForm.scss?vue&type=style&index=0&id=a65319f0&lang=scss&scoped=true"
import "./SearchForm.vue?vue&type=style&index=1&id=a65319f0&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65319f0"]])

export default __exports__